function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Group_3898",
  "data-name": "Group 3898",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, props), /*#__PURE__*/React.createElement("path", {
  id: "Path_1204",
  "data-name": "Path 1204",
  d: "M11 13h2v4h-2zm4-2h2v6h-2zM7 8h2v9H7zm8-4H5v16h14V8h-4zM3 2.992A1 1 0 014 2h12l5 5v13.993A1 1 0 0120.007 22H3.993A1 1 0 013 21.008z",
  fill: "#fff"
})));